export function ConnectLOK(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/lok`;
}

export function CreateConnectSession(organizationID: number, provider: string): string {
	return `/v1/organizations/${organizationID}/integrations/${provider}/connect-session`;
}

export function CreateXeroFeeContact(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/xero/fee-contact`;
}

export function Disconnect(organizationID: number, provider: string): string {
	return `/v1/organizations/${organizationID}/integrations/${provider}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations`;
}

export function LokSyncRuns(organizationID: number): string {
	return `/v1/organizations/${organizationID}/lok-sync-runs`;
}

export function UpdateXeroSettings(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/xero/settings`;
}

export function UpdateXeroTenant(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/xero/tenant`;
}

export function XeroAccounts(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/xero/accounts`;
}

export function XeroContacts(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/xero/contacts`;
}

export function XeroSettings(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/xero/settings`;
}

export function XeroTaxRates(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/xero/tax-rates`;
}

export function XeroTenants(organizationID: number): string {
	return `/v1/organizations/${organizationID}/integrations/xero/tenants`;
}

